import * as React from 'react';
import {Row, Col} from 'react-bootstrap';
import { Field } from 'redux-form';
import { isRequired, isValidDate, normalizeCurrency } from '../../../../util/validators';
import FieldFormControl from '../../../../components/FieldFormControl';
import SelectControl from '../../../../components/SelectControl';
import FaCheck from 'react-icons/fa/check';
import FaClose from 'react-icons/fa/close';
import AlternativeDatePicker from '../../../../components/AlternativeDatePicker';
import {Moment} from 'moment';

interface IDeclarationQuestionsProps {
  questions: IQuestion[];
  allowValidation?: boolean;
  renderDefinition: any;
}

interface IButton {
  label: string;
  value: string;
}

interface IQuestion {
  field ?: string;
  fieldType ?: string;
  options ?: any;
  content ?: any;
  type ?: string;
  className ?: string[];
  labelSize ?: number;
  question ?: string;
  buttonWidth ?: number;
  buttons ?: IButton[];
  minDate ?: Moment;
  maxDate ?: Moment;

  yes ?: string;
  no ?: string;

  single ?: boolean;

  deferredStartDate ?: boolean;
  deferredStartDateMessage ?: string;
}

class DeclarationQuestions extends React.Component<IDeclarationQuestionsProps> {
  public state = {
    viewFullBenefits: false,
  };

  public static defaultProps: Partial<IDeclarationQuestionsProps> = {
    allowValidation: true,
  };

  public render() {

    const { questions, renderDefinition } = this.props;

    return (
      <div className="declaration-container">
        {questions.map((question, index) => {
          if (! question) {
            return null;
          }

          if (question.hasOwnProperty('type')) {
            if (question.type === 'divider') {
              return (
                <hr key={index}/>
              );
            }
            if (question.type === 'content') {
              return (
                <span key={index}>
                  {question.content()}
                </span>
              );
            }
          }

          const className = ['declaration-section'];
          if (question.hasOwnProperty('className')) {
            className.push(...question.className);
          }

          const isSingle = question.hasOwnProperty('single') && question.single;

          return (
            <div className={className.join(' ')} key={index} data-s={index}>
              <Row>
                <Col sm={question.hasOwnProperty('labelSize') ? question.labelSize : 9}>
                  {renderDefinition(question.field)}
                  <span dangerouslySetInnerHTML={{ __html: question.question }} />
                </Col>
                <Col sm={question.hasOwnProperty('labelSize') ? 12 - question.labelSize : 3}>
                  {question.hasOwnProperty('fieldType') && question.fieldType === 'currency' && (
                    <Field
                      addOn={'€'}
                      currency={true}
                      type="inputGroup"
                      name={question.field}
                      normalize={normalizeCurrency}
                      component={FieldFormControl}
                      validate={[ isRequired ]}
                    />
                  )}

                  {question.hasOwnProperty('fieldType') && question.fieldType === 'number' && (
                    <Field
                      isNumber={true}
                      type="inputGroup"
                      name={question.field}
                      component={FieldFormControl}
                      validate={[ isRequired ]}
                    />
                  )}

                  {question.hasOwnProperty('fieldType') && question.fieldType === 'text' && (
                    <Field
                      type={'inputGroup'}
                      name={question.field}
                      component={FieldFormControl}
                      validate={[ isRequired ]}
                    />
                  )}

                  {question.hasOwnProperty('fieldType') && question.fieldType === 'select' && (
                    <div className="input-group">
                      <Field
                        name={question.field}
                        component={SelectControl}
                        options={question.options}
                        validate={[ isRequired ]}
                      />
                    </div>
                  )}

                  {question.hasOwnProperty('fieldType') && question.fieldType === 'button-group' && (
                    <div>
                      {question.buttons.map((button, index) => {
                        return (
                          <Col key={index} sm={question.buttonWidth}>
                            <Field
                              name={question.field}
                              type="radio"
                              format={null}
                              value={button.value}
                              className="answer"
                              component={FieldFormControl}
                              validate={[ isRequired ]}
                            >
                              <div className="declaration-btn">
                                {button.label}
                              </div>
                            </Field>
                          </Col>
                        );
                      })}
                    </div>
                  )}

                  {question.hasOwnProperty('fieldType') && question.fieldType === 'date' && (
                    <Col sm={12}>
                      <div className="alternative-date-picker field-icon-group">
                        <div className="field">
                          <Field
                            name={question.field}
                            type="masked-date"
                            placeholder="dd/mm/yyyy"
                            component={FieldFormControl}
                          />
                        </div>
                        <div className="icon">
                          <Field
                            name={question.field}
                            component={AlternativeDatePicker}
                            validate={[ isRequired, isValidDate ]}
                            minDate={question.minDate ? question.minDate : false}
                            maxDate={question.maxDate ? question.maxDate : false}
                          />
                        </div>
                      </div>
                      {question.deferredStartDate && (
                        <div className="deferred-start-date">
                          {question.deferredStartDateMessage}
                        </div>
                      )}
                    </Col>
                  )}

                  {! question.hasOwnProperty('fieldType') && (
                    <span>
                      <Col xs={isSingle ? 12 : 6}>
                        <Field
                          name={question.field}
                          type="radio"
                          format={null}
                          value={'true'}
                          complexValue={true}
                          className="answer"
                          component={FieldFormControl}
                          validate={this.props.allowValidation ? [ isRequired ] : []}
                        >
                          <div className="declaration-btn">
                            <FaCheck className={'icon'} /> {question.hasOwnProperty('yes') ? question.yes : 'Oui'}
                          </div>
                        </Field>
                      </Col>
                      {! isSingle && (
                        <Col xs={6}>
                          <Field
                            name={question.field}
                            type="radio"
                            format={null}
                            value={'false'}
                            complexValue={true}
                            className="answer"
                            component={FieldFormControl}
                            validate={this.props.allowValidation ? [ isRequired ] : []}
                          >
                            <div className="declaration-btn">
                              <FaClose className={'icon'}/> {question.hasOwnProperty('no') ? question.no : 'Non'}
                            </div>
                          </Field>
                        </Col>
                      )}
                    </span>
                  )}
                </Col>
              </Row>
            </div>
          );
        })}
      </div>
    );
  }
}

export default DeclarationQuestions;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/DeclarationQuestions/index.tsx